import { render, staticRenderFns } from "./logisticsRec.vue?vue&type=template&id=670885b4&scoped=true&"
import script from "./logisticsRec.vue?vue&type=script&lang=js&"
export * from "./logisticsRec.vue?vue&type=script&lang=js&"
import style0 from "./logisticsRec.vue?vue&type=style&index=0&id=670885b4&lang=less&scoped=true&"
import style1 from "./logisticsRec.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670885b4",
  null
  
)

component.options.__file = "logisticsRec.vue"
export default component.exports